import { useNavigate } from 'react-router-dom';
import { Card, CardHeader } from '../components';
import { SearchForm } from '../features/search/SearchForm';
import { useCreateSearch } from '../hooks/use-searches';
import { describeError } from '../services/errors';
import type { CreateSearchPayload } from '../types/api';

export function NewSearchPage() {
  const navigate = useNavigate();
  const createSearch = useCreateSearch();

  const handleSubmit = async (payload: CreateSearchPayload): Promise<void> => {
    try {
      const created = await createSearch.mutateAsync(payload);
      // Leva direto ao acompanhamento: a coleta é assíncrona e o usuário
      // precisa ver o progresso, não um "enviado com sucesso" sem contexto.
      navigate(`/pesquisas/${created.searchId}`);
    } catch {
      // Mensagem renderizada pelo formulário a partir de `createSearch.error`.
    }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <Card>
        <CardHeader
          title="Nova pesquisa"
          description="A coleta roda em segundo plano. Você acompanha o progresso na próxima tela."
        />
        <SearchForm
          onSubmit={handleSubmit}
          submitting={createSearch.isPending}
          errorMessage={createSearch.isError ? describeError(createSearch.error) : undefined}
        />
      </Card>
    </div>
  );
}
